var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 49,
    viewBox: "0 0 59 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8468 0.0381165H0.477051V11.9056H40.3307C43.9851 11.9056 44.3298 14.8376 44.3298 18.5374C44.3298 22.2373 43.9851 25.1692 40.3307 25.1692H0.477051V48.9042H15.1636V37.0367H45.8468C55.9826 37.0367 58.4648 28.7295 58.4648 18.5374C58.4648 8.34536 55.9826 0.0381165 45.8468 0.0381165Z",
    fill: "#4D0D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimationLogo);
export default __webpack_public_path__ + "static/media/animation-logo.8b9a5d65bcbd20f72fa1d1e9c40a2c46.svg";
export { ForwardRef as ReactComponent };